import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectEventDetails = (state: IRootMachineSnapshot) => {
  return state.context.eventDetails;
};

export const selectPrimaryGuestName = (state: IRootMachineSnapshot) => {
  return state.context.eventDetails?.primary_guest_name;
};
